export default function AttachReportPackageReportFolderController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  reportsDataService
) {
  const vm = this;

  vm.isExpanded = false;
  
  vm.reportInstancesLoaded = false;
  vm.reportInstanceArchivesLoaded = false;

  vm.handleExpandFolder = _handleExpandFolder;

  function _handleExpandFolder() {
    vm.isExpanded = !vm.isExpanded;

    if (vm.isExpanded) {
      return $q.all([
        _refreshReportInstances(),
        _refreshReportInstanceArchives()
      ]);
    }
  }

  function _refreshReportInstances() {
    const dfdRefresh = $q.defer();

    if (!vm.reportInstancesLoaded) {
      vm.reportInstances = vm.reportFolder.reportInstances;

      if ((vm.reportInstances !== null) && (vm.reportInstances.length > 0)) {
        loaderService.showViewLoader = true;
        reportsDataService.getReportPackageReportsByReportPackage(vm.reportPackageId).then((response) => {
          const assignedReports = response.data.result;
          if (assignedReports.length > 0) {
            assignedReports.forEach((assignedReport) => {
              vm.reportInstances.forEach((report) => {
                if ((report.reportInstanceId === assignedReport.reportInstanceId)
                  && (assignedReport.reportPackageId === vm.reportPackageId)) {
                  report.reportPackageReportInstanceId = assignedReport.reportPackageReportInstanceId;
                  report.attached = true;
                }
              });
            });
          }
          loaderService.showViewLoader = false;
        });
      }

      vm.reportInstancesLoaded = true;
    }
  }

  function _refreshReportInstanceArchives() {
    const dfdRefresh = $q.defer();

    if (!vm.reportInstancesArchivesLoaded) {
      vm.reportInstanceArchives = vm.reportFolder.reportInstanceArchives;

      if ((vm.reportInstanceArchives !== null) && (vm.reportInstanceArchives.length > 0)) {
        loaderService.showViewLoader = true;
        reportsDataService.getReportPackageReportsByReportPackage(vm.reportPackageId).then((response) => {
          const assignedReports = response.data.result;
          if (assignedReports.length > 0) {
            assignedReports.forEach((assignedReport) => {
              vm.reportInstanceArchives.forEach((archivedReport) => {
                if ((archivedReport.reportInstanceArchiveId === assignedReport.reportInstanceArchiveId) && (assignedReport.reportPackageId === vm.reportPackageId)) {
                  archivedReport.reportPackageReportInstanceId = assignedReport.reportPackageReportInstanceId;
                  archivedReport.attached = true;
                }
              });
            });
          }
          loaderService.showViewLoader = false;
        });
      }

      vm.reportInstancesArchivesLoaded = true;
    }

    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }
}

AttachReportPackageReportFolderController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'reportsDataService'
];
